import swKE from './sw-KE';
import soSO from './so_SO';
import xhZA from './xh-ZA';
import bsBA from './bs-BA';
import azAZ from './az-AZ';
import amET from './am-ET';
import hiIN from './hi-IN';
import neNP from './ne-NP';

export { swKE, soSO, xhZA, bsBA, azAZ, amET, hiIN, neNP };
